// Applique l'espacement (densité verticale des sections) de la boutique
// (Studio de thème) en custom properties CSS sur :root — tailwind.config.js
// lit ces mêmes variables (py-section / md:py-section-md) avec un repli
// identique au rendu d'origine (py-16 md:py-20 = 4rem/5rem) tant qu'elles ne
// sont pas définies, exactement comme applyPalette.js/applyTypography.js/
// applyShape.js. `spacing` est la réponse DÉJÀ RÉSOLUE du backend
// (get_theme_spacing : {spacing, resolved, options}) — jamais recalculée ici.
export default function applySpacing(spacing) {
  const resolved = spacing?.resolved;
  if (!resolved) return;
  const root = document.documentElement;
  if (resolved.section_y) root.style.setProperty("--space-section-y", resolved.section_y);
  if (resolved.section_y_md) root.style.setProperty("--space-section-y-md", resolved.section_y_md);
  if (resolved.section_top) root.style.setProperty("--space-section-top", resolved.section_top);
  if (resolved.section_top_md) root.style.setProperty("--space-section-top-md", resolved.section_top_md);
}
